import { jsx as e } from "react/jsx-runtime";
//#region src/components/icons/icons.tsx
var t = ({ name: t, className: n = "", size: r = "lg" }) => {
	let i = 24;
	switch (r) {
		case "sm":
			i = 16;
			break;
		case "md":
			i = 20;
			break;
		case "xl":
			i = 32;
			break;
		case "mega":
			i = 40;
			break;
	}
	return /* @__PURE__ */ e("span", {
		style: { fontSize: i },
		className: `icon ${n} font-light material-symbols-outlined`,
		children: t
	});
};
//#endregion
export { t as Icon };
